import { isEmptyString, isValidEmail } from "../../../utils/functions";
import { useSearchParams } from "react-router-dom";

export const useSignupEffect = (setSignupErrors, isGenderPage, setGenderPage) => {
    const [params] = useSearchParams();
    const ref = params.get('ref');

    const createAccount = (e) => {
        e.preventDefault();

        setSignupErrors([]);

        let formData = new FormData(e.target);
        const email = formData.get("email");
        const password = formData.get("password");
        const confirmPassword = formData.get('cpassword');
        const countryCode = "+234"; //formData.get("country-code");
        const phoneNumber = formData.get('ph-number');
        const firstName = formData.get("firstName");
        const lastName = formData.get("lastName");
        const gender = formData.get("gender");

        if (ref) {
            formData.append('referralCode', ref);
        }
        
        if (
            isValidEmail(email)
            && password.length >= 8 
            && !isEmptyString(firstName) 
            && !isEmptyString(lastName) 
            && !isEmptyString(phoneNumber)
            && ( password === confirmPassword && !isEmptyString(password) )  ) {
                if(!isGenderPage){
                    setGenderPage(true);
                }
                else {

                    if(!gender){
                        setSignupErrors(prevErrors => [...prevErrors, "Select a gender."]);
                        return;
                    }

                // add country code to phoneNumber and append it to formData 
                // remove ph-number and country-code from formdata
                    formData.append("phoneNumber", countryCode + phoneNumber);
                    formData.delete("ph-number");
                    formData.delete('cpassword');

                    return {formData, submit: true};
                }
        } else {
            if(isEmptyString(firstName)) setSignupErrors(prevErrors => [...prevErrors, "First name cannot be empty."]);
            if(isEmptyString(lastName)) setSignupErrors(prevErrors => [...prevErrors, "Last name cannot be empty."]);
            if(!isValidEmail(email)) setSignupErrors(prevErrors => [...prevErrors, "Email address is not valid."]);
            if(isEmptyString(phoneNumber)) setSignupErrors(prevErrors => [...prevErrors, "Phone number cannot be empty."]);
            if (password.length < 8) setSignupErrors(prevErrors => [...prevErrors, "Password cannot be less than 8 characters.."]);
            else if ( password !== confirmPassword ) setSignupErrors(prevErrors => [...prevErrors, "Password does not match confirm password."]);
        }

    }

    return { createAccount }
}